import { render, staticRenderFns } from "./ContactFooter.vue?vue&type=template&id=be736fec&scoped=true"
import script from "./ContactFooter.vue?vue&type=script&lang=js"
export * from "./ContactFooter.vue?vue&type=script&lang=js"
import style0 from "./ContactFooter.vue?vue&type=style&index=0&id=be736fec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be736fec",
  null
  
)

export default component.exports